import { createApp, ref } from "vue";
import App from "@/App.vue";
import store from '@/store'
import router from '@/router'
import KeyCloakService from "@/security/KeycloakService";
import { i18n } from "@/i18n"
import Buefy from "buefy";
import 'buefy/dist/css/buefy.css'
import "@/assets/styles.scss";
import '@mdi/font/css/materialdesignicons.css'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faTachometerAlt, faMicrochip, faList, faPuzzlePiece, faKey, faUserGear, faCode } from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faTachometerAlt, faMicrochip, faList, faPuzzlePiece, faKey, faUserGear, faCode)

const isDarkMode = ref(false);

const setDarkMode = (enable: boolean) => {
  const newBodyClass = enable ? 'dark' : '';
  const body = document.querySelector('body');
  if (body) {
    body.className = newBodyClass;
  }
  isDarkMode.value = enable;
}

const renderApp = () => {
  const app = createApp(App, {});
  store.dispatch('loadModel', { model: 'user', force: true });
  store.dispatch('loadModel', { model: 'devices' });
  store.dispatch('loadModel', { model: 'settings' });
  app.component('font-awesome-icon', FontAwesomeIcon)
  app.use(store);
  app.use(i18n);
  app.use(router);
  app.use(Buefy, {
    defaultInputAutocomplete: 'off',
  });
  app.provide('keycloak', KeyCloakService.Instance);
  app.provide('isDarkMode', isDarkMode);
  app.mount('#app');
  if (window.matchMedia) {
    setDarkMode(window.matchMedia('(prefers-color-scheme: dark)').matches);
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
      setDarkMode(event.matches);
    });
  }
};

KeyCloakService.CallLogin(renderApp);
